import { useState } from 'react';
import { Application } from '../../../../../../entities/Application';
import { AlertObject, AlertType } from '../../../../../../components/Alert';
import { NoteService } from '../../../../../../services/applicant_tracking/NoteService';

interface UseApplicationNoteModalOptions {
  application: Application;
  setAlert: (alert: AlertObject) => void;
  onNoteAdded: () => void;
}

export function useApplicationNoteModal(
  options: UseApplicationNoteModalOptions,
) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const submitNote = async (note: string) => {
    try {
      await NoteService.create({
        applicationId: options.application.id,
        note,
      });
      options.setAlert({
        type: AlertType.Success,
        message: 'The note was successfully added.',
      });
      options.onNoteAdded();
    } catch (error) {
      options.setAlert({
        type: AlertType.Danger,
        message: 'There was an error adding the note.',
      });
    } finally {
      setIsOpen(false);
    }
  };

  return {
    isNoteModalOpen: isOpen,
    openNoteModal: () => setIsOpen(true),
    closeNoteModal: () => setIsOpen(false),
    submitNote,
  };
}
